<svelte:options accessors={true}/>
<script>
	import HRImport from './../../components/HR/HRImport.svelte';
	import JobRoles from './../../components/HR/JobRoles.svelte';
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import AuthService from '../../services/auth.service.js';
    import Loader from "../../components/Loader.svelte";
    import EditableCell from "../../components/EditableCell.svelte";
    import HRService from '../../services/hr.service.js';
    import ExportService from '../../services/export.service';
    //Sorting and pagination
    import EntriesSelector from './../../components/sorting/EntriesSelector.svelte';
    import Search from './../../components/sorting/Search.svelte';
    import Pagination from './../../components/sorting/Pagination.svelte';

    let page, loading = false, reportData, errorMessage,
        currentCandidate = {}, candidateToChange = {},
        currentPage = 0, search = "", sortBy = "id",
        order = true, entries = 100, totalElements = 0,
        candidateToDelete, candidatesTab="one";

    export let user, params, loadingExport = false;

    //Catch when a value change
    $: loadData(params, search, entries, currentPage, order, sortBy, entries);

    let headers = [
        {title: "Candidate Name", key: "name", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 140, exportWidth: 20 },
        {title: "Req #", key: "req_id", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 14 },
        {title: "Department", key: "department", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "departments", width: 100, exportWidth: 15 },
        {title: "Job Title", key: "job_title", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 230, exportWidth: 35 },
        {title: "job role", key: "job_role", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "jobRoles", width: 300, exportWidth: 30 },
        {title: "Source", key: "source", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "sources", width: 80, exportWidth: 20  },
        {title: "Agency | Job Board", key: "agency", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 170, exportWidth: 20  },
        {title: "Date Agency Engaged /\n Job First Posted", key: "post_date", customClass : "", editable: true, type: "date", format: 7, width: 160, exportWidth: 30  },
        {title: "Resume Received", key: "resume_received", customClass : "", editable: true, type: "date", format: 7, width: 140, exportWidth: 22  }
    ];

    onMount(() => {
        loadData();
    });

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = '/org/' + params.org + '/hr_candidates/' + currentPage + "/" + sortBy
        + "/" + order + "/" + entries + getSearch();
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        if (reportData && reportData.totalElements) totalElements = reportData.totalElements;

        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    export const exportToExcel = async () => {
        loadingExport = true;

        try {
            const url = `/org/${params.org}/export/hr_candidates/0/id/true/1000`;
            const candidatesReport = (await ReportsService.load(url)).data;
            const isFacilitator = !AuthService.can('EXPORT_HR_ALL_PORTCOS');
            const fileName = (!isFacilitator)? 'HR-Candidates':`HR-Candidates-${jQuery('#dropdownOrganizations').text()}`;

            if (!candidatesReport && !candidatesReport.totalElements) {
                alert('Nothing to export');
            } else {
                const stageHeaders =
                    candidatesReport.
                    candidates[0].
                    candidate_trackings
                    .map((candidate_tracking, index) => ({
                            index,
                            title: candidate_tracking.stage,
                            exportWidth: 15,
                            isStageHeader: true,
                        })
                    );

                const companyHeader = {title: 'Company', key: 'company', exportWidth: 24};

                const allHeaders = [
                    ...headers,
                    ...stageHeaders,
                    {title: 'Notes', key: 'notes', exportWidth: 15},
                    {title: 'Time to fill', key: 'time_to_fill', exportWidth: 40},
                ];

                if (!isFacilitator) {
                    allHeaders.unshift(companyHeader);
                }

                await ExportService.downloadCandidates(
                    candidatesReport.candidates,
                    allHeaders,
                    fileName,
                    isFacilitator,
                );
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }

    };

    function getSearch(){
        return (search)? "/" + search : '';
    }

    export const onSearch = function(searchText){
        search = searchText;
    }

    let onSaveCandidate = async function() {
        let response = null;
        try {
            if(currentCandidate.id){
                if(JSON.stringify(currentCandidate) != JSON.stringify(candidateToChange)){
                    await ReportsService.updateCandidate(currentCandidate);
                    loadData();
                }
            }else{
                await ReportsService.saveCandidate(currentCandidate);
                loadData();
            }
            jQuery('#addCandidate').modal('hide');
            cleanCandidate();
        } catch (e) {
            errorMessage = e.message;
            console.log(errorMessage);
        }
    }

    function cleanCandidate() {
        currentCandidate = {
            id: '',
            req_id: '',
            department: reportData.options.departments[0].value,
            job_title: '',
            job_role: '',
            source: reportData.options.sources[0].value,
            agency: '',
            name: '',
            organization_id: params.org,
            post_date:'',
            candidates_amount: 1
        };
    }

    export const addRow = function(){
        cleanCandidate();
        jQuery('#addCandidate').modal('show');
    }

    function editCandidate(candidateToEdit){
        currentCandidate = JSON.parse(candidateToEdit);
        candidateToChange = {... currentCandidate };
        jQuery('#addCandidate').modal('show');
    }

    let updateTracking = async function(tracking, date, status){
        //Set changed value
        if(date){
            tracking.date = date;
        }else{
            tracking.status = status;
        }
        //Update tracking
        try {
            let result = await ReportsService.updateCandidateTRacking(tracking);
            if (result.data.stage == "Start"){
                //Get time to fill column data
                await loadData();
                jQuery('#reportsDiv').scrollLeft(3000);
            }
        } catch (e) {
            errorMessage = e.message;
            console.log(errorMessage);
        }
    }

    async function updateCandidateData(value, id, field){
        if(jQuery('.hr-pasting').length > 0){
            //Avoid save all the string pasted on the selected cell
            return false;
        }

        try {
            let model = (field == 'notes') ? 'candidates' : HRService.getFieldModel(field);
            await ReportsService.updateCandidateData({value, id, field}, model);
        } catch (e) {
            console.log('Error', e);
        }
    }

    export function selectEntries(entriesSelected){
        console.log(entriesSelected)
        currentPage = 0;
        entries = entriesSelected;
    }

    function sort(key){
        //If it's a different column, set asc bt default. If not, set the opposite (asc = desc, desc = asc)
        order = (sortBy == key)? !order : true;
        sortBy = key;
    }

    function showOfferTooltip(candidateIndex) {
        jQuery('#offer-status-'+candidateIndex).tooltip('show');
    }

    function hideOfferTooltip(candidateIndex) {
        jQuery('#offer-status-'+candidateIndex).tooltip('hide');
    }

    let openJobRolesModal = function(){
        jQuery('#jobRolesModal').modal('show');
    }

    function openDeleteCandidateModal(candidateId){
        candidateToDelete = candidateId;
        jQuery('#deleteCandidateConfirmation').modal('show');
    }

    async function deleteCandidate(){
        try {
            await ReportsService.deleteCandidate(candidateToDelete);
            jQuery('#deleteCandidateConfirmation').modal('hide');
            loadData();
        } catch (e) {
            console.log('Error', e);
        }
    }

    //Import
    export const openImportModal = function(){
        jQuery('#importModal').modal('show');
    }

    let onImported = async function(){
        jQuery('#importModal').modal('hide');
        await loadData();
    }
</script>

<!-- Add/edit candidate and add/edit tracking stages-->
<div class="modal fade" id="addCandidate" tabindex="-1" role="dialog" aria-labelledby="addCandidate" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    {#if currentCandidate.id}
                        Edit Candidate
                    {:else}
                        Add Candidate
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form on:submit|preventDefault={onSaveCandidate}>
                <div class="modal-body">
                    {#if AuthService.can('EDIT_CANDIDATE') }
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="radio-inline mr-5">
                                        <input type="radio" class="mr-2" name="candidates_one" bind:group={candidatesTab} value="one">One
                                    </label>
                                    <label class="radio-inline">
                                        <input type="radio" class="mr-2" name="candidates_multiple" bind:group={candidatesTab} value="multiple">Multiple Entries
                                    </label>
                                </div>
                                {#if candidatesTab == "one"}
                                    {#if reportData && reportData.options}
                                        <div class="form-group">
                                            <label for="candidate-req_id">*Req #</label>
                                            <input  bind:value={currentCandidate.req_id} type="text" class="form-control" name="candidate-req_id" id="candidate-req_id" placeholder="210191">
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-name">*Name</label>
                                            <input  bind:value={currentCandidate.name} type="text" class="form-control" name="candidate-name" id="candidate-name" placeholder="John Doe">
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-department">*Department</label>
                                            <select bind:value={currentCandidate.department}  class="form-control" name="candidate-department" id="candidate-department">
                                                {#each reportData.options.departments as department}
                                                    <option value="{department.value}">{department.option}</option>
                                                {/each}
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="nameInput">*Job Title</label>
                                            <input required bind:value={currentCandidate.job_title} type="text" class="form-control" name="candidate-job_title" id="candidate-job_title" placeholder="Marketing Contractor">
                                        </div>
                                        <div class="form-group">
                                            <label for="nameInput">*Job Role</label>
                                            <select bind:value={currentCandidate.job_role}  class="form-control" name="candidate-source" id="candidate-source">
                                            {#each reportData.options.jobRoles as jobRole}
                                                <option value="{jobRole.value}">{jobRole.option}</option>
                                            {/each}
                                        </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-source">*Source</label>
                                            <select bind:value={currentCandidate.source}  class="form-control" name="candidate-source" id="candidate-source">
                                                {#each reportData.options.sources as source}
                                                    <option value="{source.value}">{source.option}</option>
                                                {/each}
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-agency">*Agency | Job Board</label>
                                            <input required bind:value={currentCandidate.agency} type="text" class="form-control" name="candidate-agency" id="candidate-agency" placeholder="Linkedin">
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-posted_date">*Job First Posted</label>
                                            <input required bind:value={currentCandidate.post_date} type="date" class="form-control" name="candidate-posted_date" id="candidate-posted_date">
                                        </div>
                                        <div class="form-group">
                                            <label for="candidate-notes">Notes</label>
                                            <textarea bind:value={currentCandidate.notes} type="text" class="form-control textarea-two_lines" id="candidate-notes" placeholder="Notes" rows="5"></textarea>
                                        </div>
                                    {/if}
                                {:else}
                                    <div class="form-group">
                                        <label for="candidate-req_id">* Number of candidates to add</label>
                                        <input  bind:value={currentCandidate.candidates_amount} type="number" min="1" max="30" class="form-control" name="candidate-amount" id="candidate-amount" placeholder="10">
                                    </div>
                                {/if}
                            </div>
                        </div>
                    {/if}

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanCandidate}>Close</button>

                    <button type="submit" class="btn btn-success">
                        {#if currentCandidate.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete candidate -->
<div class="modal fade" id="deleteCandidateConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteCandidateConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteCandidateLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this candidate?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => deleteCandidate()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader></Loader>
{:else}
    {#if AuthService.can('IMPORT_HR_REPORTS') }
        <HRImport params={params} module="candidates" on:imported={onImported}></HRImport>
    {/if}
    <JobRoles></JobRoles>
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>

    <div class="table-wrapper hr-report">
        <table class="table table-sm container-fluid table-weekly selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="delete-cell" rowspan="2"></th>
                    {#each headers as header, headerIndex}
                        <!-- <th rowspan="2" style="min-width:{header.width}px" class="col-subheader {header.customClass}">{header.title}</th> -->
                        {#if header.editable}
                            <th
                              rowspan="2"
                              style="min-width: {header.width}px"
                              class="col-subheader {header.customClass} {headerIndex > 4 ? 'notFixed' : '' }">
                                <span class="pointer" on:click={() => sort(header.key)}>
                                    {header.title}
                                    <i class="fa fa-sort-{(sortBy == header.key && !order) ? 'desc' : 'asc' } {(sortBy == header.key) ? 'text-primary' : '' }"></i>
                                </span>
                                {#if header.key == 'job_role'}
                                    <i
                                        class="fa fa-info-circle ml-2 mr-1 vertical-middle pointer"
                                        on:click={ openJobRolesModal }
                                    ></i>
                                {/if}
                            </th>
                        {:else}
                             <th style="min-width: {header.width}px" class="col-subheader {header.customClass}">{header.title} {headerIndex > 4 ? 'notFixed' : '' }</th>
                        {/if}
                    {/each}
                    {#each reportData.options.trackingStages as stage}
                        <th rowspan="1" colspan="{ (stage.option != 'Start')? '2' : '1' }" class="col-subheader notFixed">{stage.option}</th>
                    {/each}
                    <th rowspan="2" class="hr-notes notFixed">Notes</th>
                    <th rowspan="2" class="notFixed">Time To Fill (Days)</th>
                </tr>
                <tr class="bg-dark text-light">
                    {#each reportData.options.trackingStages as stage, stageIndex}
                        {#if stage.option != 'Start'}
                            <th class="col-header text-center notFixed col-dropdown">Completed</th>
                            <th class="col-header text-center notFixed col-dropdown">
                                {#if stage.option != 'Offer'}
                                    Status
                                {:else}
                                    Offer Status
                                {/if}
                            </th>
                        {:else}
                             <th class="col-header text-center notFixed col-dropdown">Actual Start</th>
                        {/if}

                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.candidates as candidate, candidateIndex}
                    <tr>
                        <th class="delete-cell">
                            <i
                                class="fa fa-trash text-danger pointer"
                                on:click={() => openDeleteCandidateModal (candidate.id)}
                            ></i>
                        </th>
                        {#each headers as header, column}
                            {#if header.editable}
                                <td
                                  class="{column > 4 ? 'notFixed' : 'readOnly' } hr-cell-border ">
                                    <EditableCell
                                        id="t1-{candidateIndex}-{column}"
                                        on:change={(e) => updateCandidateData(e.detail.value, candidate.id,  header.key)}
                                        bind:value={candidate[header.key]}
                                        type={header.type}
                                        hrData="{ {candidate: candidate.id, key: header.key, model: 'candidates', format: header.format} }"
                                        selectOptions={(header.type == "select" && reportData.options[header.selectOptionsKey]) ? reportData.options[header.selectOptionsKey] : []}
                                        customClass="hr-cell" format={header.format}></EditableCell>
                                </td>
                            {:else}
                                <td class=" {column > 4 ? 'notFixed' : 'readOnly' }">{candidate[header.key] || ''}</td>
                            {/if}
                        {/each}
                        {#each reportData.options.trackingStages as stage, stageIndex}
                            {#if stage.option != 'Start'}
                                 <td class="text-center notFixed readOnly hr-cell-border">
                                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" on:change={(e) => updateTracking(candidate.tracking[stage.option], e.target.value, null)}
                                        disabled={!candidate.tracking[stage.option].status || candidate.tracking[stage.option].status == "0"}
                                        bind:value={candidate.tracking[stage.option].date}
                                        class="hr-cell" >
                                </td>
                                <td class="text-center notFixed readOnly hr-cell-border" >
                                    {#if stage.option == 'Offer'}
                                        <select
                                            on:change={(e) => updateTracking(candidate.tracking[stage.option], null, e.target.value)}
                                            class="hr-cell"
                                            id="offer-status-{candidateIndex}"
                                            bind:value={candidate.tracking[stage.option].status}
                                            data-toggle="tooltip" data-placement="left"
                                            title="Offer status has to be accepted to enter a hire date"
                                        >
                                            <option value="0"></option>
                                            {#if stage.option == 'Offer'}
                                                {#each reportData.options.trackingStatusesOffer as trackingStatus}
                                                    <option value="{trackingStatus.value}">{trackingStatus.option}</option>
                                                {/each}
                                            {:else}
                                                {#each reportData.options.trackingStatuses as trackingStatus}
                                                    <option value="{trackingStatus.value}">{trackingStatus.option}</option>
                                                {/each}
                                            {/if}
                                        </select>
                                    {:else}
                                        <select
                                            on:change={(e) => updateTracking(candidate.tracking[stage.option], null, e.target.value)}
                                            class="hr-cell"
                                            bind:value={candidate.tracking[stage.option].status}
                                        >
                                            <option value="0"></option>
                                            {#if stage.option == 'Offer'}
                                                {#each reportData.options.trackingStatusesOffer as trackingStatus}
                                                    <option value="{trackingStatus.value}">{trackingStatus.option}</option>
                                                {/each}
                                            {:else}
                                                {#each reportData.options.trackingStatuses as trackingStatus}
                                                    <option value="{trackingStatus.value}">{trackingStatus.option}</option>
                                                {/each}
                                            {/if}
                                        </select>
                                    {/if}
                                </td>
                            {:else if stage.option}
                                {#if candidate.tracking['Offer'].status != 4}
                                    <td class="text-center notFixed readOnly hr-cell-border disabled-td"
                                        on:mouseenter={ () => showOfferTooltip(candidateIndex) }
                                        on:mouseleave={ () => hideOfferTooltip(candidateIndex) }
                                    >
                                        mm / dd / yyyy
                                    </td>
                                {:else}
                                     <td class="text-center notFixed readOnly hr-cell-border">
                                        <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')"
                                            on:change={(e) => updateTracking(candidate.tracking[stage.option], e.target.value, null)}
                                            bind:value={candidate.tracking[stage.option].date}
                                            class="hr-cell"
                                        >
                                    </td>
                                {/if}
                            {/if}
                        {/each}
                        <td
                            class="notFixed readOnly hr-cell-border hr-notes text-truncate">
                            <EditableCell
                            id="t1-{candidateIndex}-25"
                            on:change={(e) => updateCandidateData(e.detail.value, candidate.id, "notes")}
                            bind:value={candidate.notes}
                            type="text"
                            customClass="hr-cell" format="7"></EditableCell>
                        </td>
                        <td class="notFixed readOnly">{candidate.time_to_fill}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <Pagination {currentPage} {entries}  {totalElements} on:change={(e) => currentPage = e.detail.page} />
{/if}

<style>
    .disabled-td{
        background-color: lightgray !important;
        cursor: not-allowed;
        word-spacing: -2px;
    }
</style>
